import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import { LoaderFunctionArgs, redirect, useLoaderData } from "react-router";

import classNames from "classnames";

import { currencyFormat } from "@lib/utils";

import "../../assets/css/majorybl/pages/register.scss";
import { getOrder, getStripeOrder } from "../../lib/api";
import { IAPIResponse, IOrder } from "../../types/api";
import ProductDetails from "../LeagueManagement/Order/components/ProductDetails";

export const loader = async ({ request }: LoaderFunctionArgs) => {
    const url = new URL(request.url);
    const orderId = url.searchParams.get("order_id");
    const paymentIntent = url.searchParams.get("payment_intent");

    if (orderId) {
        const parsedOrderId = parseInt(orderId);

        if (Number.isNaN(parsedOrderId)) {
            return redirect("/");
        }

        return await getOrder(parsedOrderId);
    } else if (paymentIntent) {
        return await getStripeOrder(paymentIntent);
    } else {
        return redirect("/");
    }
};
const ThankYou = (): React.JSX.Element => {
    const { paymentStatus, order } = useLoaderData() as IAPIResponse & {
        paymentStatus: string;
        order: IOrder;
    };

    let header = "";
    switch (paymentStatus) {
        case "succeeded":
            header = "Checkout complete!";
            break;
        case "processing":
            header = "Your payment is processing";
            break;
        default:
            header = "Thank you for your order";
            break;
    }

    return (
        <Container className="py-5 thankYou">
            <Row>
                <Col md={6}>
                    <h2>{header}</h2>
                    <br />
                    <h3>Order Details:</h3>
                    {order.products
                        ? order.products.map((p, idx) => (
                              <ProductDetails
                                  key={idx}
                                  product={p}
                                  order={order}
                              />
                          ))
                        : ""}
                    <Table
                        borderless
                        aria-label="Order totals"
                        className="productDetails"
                    >
                        <tbody>
                            {/* Only show checkDiscount because product prices already include any promo code discounts */}
                            {(Number(order.checkDiscount) || 0) > 0 && (
                                <tr>
                                    <td>
                                        <h5>Check Discount:</h5>
                                    </td>
                                    <td>
                                        {currencyFormat.format(
                                            Number(order.checkDiscount) || 0,
                                        )}
                                    </td>
                                </tr>
                            )}
                            <tr>
                                <td>
                                    <h5>Total:</h5>
                                </td>
                                <td>
                                    {/* Total is pre-discount order total so we subtract both discount (promo codes) and checkDiscount here */}
                                    {currencyFormat.format(
                                        Number(order.total) -
                                            ((Number(order.discount) || 0) +
                                                (Number(order.checkDiscount) ||
                                                    0)),
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Container>
    );
};

export default ThankYou;
